import {
    IconButton,
    Button,
    TableContainer,
    Table,
    TableBody,
    TableRow,
    TableCell,
} from "@mui/material";

import { useRef } from "react";

import PrintIcon from '@mui/icons-material/Print';
import CopyrightIcon from "@mui/icons-material/Copyright";

import PageHeader from "./PageHeader";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import RekendeelTable from "./RekendeelTable";
import Voorschot from "./Voorschot";

export default function PrintDocument(props) {

    const page1Ref = useRef();
    const page2Ref = useRef();

    const fhMinus1 = props.fhMinus1;
    const fhMinus2 = props.fhMinus2;
    const fhMinus3 = props.fhMinus3;
    const fhAvg = props.fhAvg;
    const saldibalans = props.saldibalans;
    const opgeteld = props.opgeteld;
    const betrokkene = props.betrokkene;

    const printVoorschot = async () => {
        const pdf = new jsPDF("landscape", "px", "a4");
        const margin = 20;
        const pdfWidth = pdf.internal.pageSize.getWidth() - 2 * margin;
        const pdfHeight = pdf.internal.pageSize.getHeight() - 2 * margin;
        const filename = betrokkene.kenmerk + "-" + betrokkene.naamOnderneming + ".pdf"
        // const pdfHeight = canvas.height;

        // Helper to capture content and add to PDF
        const addPageFromRef = async (ref, isLastPage = false) => {
            const element = ref.current;
            const canvas = await html2canvas(element, { scale: 2 });
            const imgData = canvas.toDataURL("image/png");

            pdf.addImage(imgData, "PNG", margin, margin, pdfWidth, pdfHeight);
            if (!isLastPage) {
                pdf.addPage();
            }
        };

        await addPageFromRef(page1Ref);
        await addPageFromRef(page2Ref, true);

        pdf.save(filename);
    };

    return (
        <div>
            <IconButton>
                <Button variant="outlined" endIcon={<PrintIcon />} onClick={printVoorschot} >Print VoorSchot</Button>
            </IconButton>
            <div ref={page1Ref}>
                <PageHeader
                    betrokkene={betrokkene}
                />
                <RekendeelTable
                    fhMinus1={fhMinus1}
                    fhMinus2={fhMinus2}
                    fhMinus3={fhMinus3}
                    fhAvg={fhAvg}
                    saldibalans={saldibalans}
                    opgeteld={opgeteld}
                    betrokkene={betrokkene}
                    printSet="all"
                />
                <TableContainer>
                    <Table style={{ borderStyle: "none", borderWidth: 0 }}>
                        <TableBody>
                            <TableRow style={{ borderStyle: "none", borderWidth: 0 }}>
                                <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: "double", fontWeight: "bolder" }} align="left"><CopyrightIcon /> - Athenos</TableCell>
                                <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: "double", fontWeight: "bolder" }} align="right">Page 1 of 2</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <div ref={page2Ref}>
                <PageHeader
                    betrokkene={betrokkene}
                />
                <RekendeelTable
                    fhMinus1={fhMinus1}
                    fhMinus2={fhMinus2}
                    fhMinus3={fhMinus3}
                    fhAvg={fhAvg}
                    saldibalans={saldibalans}
                    opgeteld={opgeteld}
                    betrokkene={betrokkene}
                    printSet="p2"
                />
                <Voorschot
                    betrokkene={betrokkene}
                />
                <TableContainer>
                    <Table style={{ borderStyle: "none", borderWidth: 0 }}>
                        <TableBody>
                            <TableRow style={{ borderStyle: "none", borderWidth: 0 }}>
                                <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: "double", fontWeight: "bolder" }} align="left"><CopyrightIcon /> - Athenos</TableCell>
                                <TableCell sx={{ height: 20, paddingTop: 0.5, paddingBottom: 0, borderTopStyle: "double", fontWeight: "bolder" }} align="right">Page 2 of 2</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
            <IconButton>
                <Button variant="outlined" endIcon={<PrintIcon />} onClick={printVoorschot} >Print VoorSchot</Button>
            </IconButton>
        </div>
    )
}

